import React, { useState } from "react";
import { IoMdClose } from "react-icons/io";
import StepOneForm from "../components/StepOneForm";
import StepTwoForm from "../components/StepTwoForm";
import FormContext from "../components/FormContext";
const AddNewDistributor = ({
  setModal,
  fetchUsers,
  setAddNewModal,
  setAddedSuccess,
  setExistError,
  editData,
  setAddErrorMessage,
}) => {
  const [formStep, setFormStep] = useState(1);

  return (
    <div className="overlay z-50">
      <div
        className={`modal !w-[468px]  ${
          formStep === 1 ? "!h-fit" : "!h-fit"
        } !p-0 !text-left `}
      >
        <div className=" w-full h-full p-6 flex flex-col">
          <div className=" flex justify-between">
            <p className=" text-base font-bold w">Add New Distributor</p>
            <p
              className=" cursor-pointer"
              onClick={() => {
                setModal(false);
              }}
            >
              <IoMdClose className=" w-[20px] h-[20px]" />
            </p>
          </div>
          {/* //// */}
          <FormContext editData={editData}>
            {formStep === 1 && <StepOneForm setFormStep={setFormStep} />}
            {formStep === 2 && (
              <StepTwoForm
                setFormStep={setFormStep}
                fetchUsers={fetchUsers}
                setAddNewModal={setAddNewModal}
                setAddedSuccess={setAddedSuccess}
                setExistError={setExistError}
                editData={editData}
                setAddErrorMessage={setAddErrorMessage}
              />
            )}
          </FormContext>
        </div>
      </div>
    </div>
  );
};

export default AddNewDistributor;
